import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { style: {"padding":"20px"} }
const _hoisted_6 = { style: {"padding-top":"10px","padding-bottom":"10px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import {allWithdrawal,getUserUaddress,addWithdrawal } from '../../api'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'withdrawList',
  setup(__props) {

  const uaddress = ref("");

  const balance = ref(0);
  
  const search = reactive({
    key: "",
  })
  


  const  getUserInfo=()=>{
    getUserUaddress().then((res: any) => {
          if (res != "" && res.code == 0) {
            uaddress.value=res.data.uaddress;
            balance.value=res.data.balance;
          }
        })

  }
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
   
  { title: "提现金额", key: "amount", align: "center" },
  { title: "钱包地址", key: "uaddress", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state" },
  { title: "备注", key: "remark", align: "center" },
  { title: "审核时间", key: "reviewTime", align: "center" },
  { title: "提现时间", key: "addTime", align: "center" }, 
  ]);
  
  
  const getAllAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allWithdrawal(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
   
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 
  //查询接口
  const searchUser = () => {
    page.current = 1;
    getAllAdminUser();
  }
   
  const withdrawal = reactive({
    amount: 0.0,
    payPassword: "", 
  })
  
 
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);
  
  const changeVisible11 = () => { 
    getUserInfo();
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        if (balance.value==0) {
          layer.msg("您的账号余额未到达提现最低要求。", { time: 1000, icon: 2 });
          return;
        }
        if(withdrawal.amount>balance.value){
          layer.msg("输入的提现金额有误！请重新输入。", { time: 1000, icon: 2 });
          return;
        }
        if(withdrawal.amount<1){
          layer.msg("提现金额必须大于（1元）！请重新输入。", { time: 1000, icon: 2 });
          return;
        }
        if(withdrawal.payPassword.length!=6){
          layer.msg("支付密码错误！请重新输入。", { time: 1000, icon: 2 });
          return;
        }
 
        addWithdrawal(JSON.stringify(withdrawal)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminUser();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
      }
    }
  ])
  
   
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提现")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    (row.state==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "等待审核"))
                      : (row.state==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "通过审核"))
                        : (row.state==3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "审核失败"))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['300px', '330px'],
      btn: action11.value,
      title: "提现"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, "U地址：" + _toDisplayString(uaddress.value), 1),
            _createElementVNode("div", _hoisted_6, "可提现：" + _toDisplayString(balance.value), 1)
          ]),
          _createVNode(_component_lay_form, {
            model: withdrawal,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "提现金额",
                prop: "amount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: withdrawal.amount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((withdrawal.amount) = $event)),
                    maxlength: "6",
                    type: "number",
                    max: balance.value,
                    min: 1
                  }, null, 8, ["modelValue", "max"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "支付密码",
                prop: "payPassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: withdrawal.payPassword,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((withdrawal.payPassword) = $event)),
                    maxlength: "6",
                    type: "password",
                    password: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})